var React = require('react');

function RectangleInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"4qk5xlf88a","x1":"112.839%","x2":"24.202%","y1":"20.885%","y2":"87.766%"},[React.createElement("stop",{"offset":"0%","stopColor":"#0ACCFF","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#66FFE5","key":1})])),React.createElement("rect",{"width":"383","height":"448","x":"149.481","y":"2330.337","fill":"none","fillRule":"evenodd","stroke":"url(#4qk5xlf88a)","rx":"60","transform":"rotate(-13 -9827.493 1907.008)","key":1})]);
}

RectangleInline.defaultProps = {"width":"452","height":"501","viewBox":"0 0 452 501"};

module.exports = RectangleInline;

RectangleInline.default = RectangleInline;
